module.exports = __webpack_public_path__ + "img/demand1.1b32a18c.svg";